import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'address-type-create',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatSlideToggle,
    MatInputModule,
  ],
  templateUrl: './address-type-create.component.html',
  styleUrl: './address-type-create.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class AddressTypeCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private addressTypeService: AddressTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  @Output() responseCreate = new EventEmitter()

  ngOnInit(): void {
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      active: [{ value: false }],
      description: ['', [Validators.required]],
    })
  }

  createAddressType() {
    this.loading = true
    const model = this.createModel()
    this.addressTypeService.createAddressType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.createForm()
        this.responseCreate.emit(true)
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  createModel() {
    return {
      ativo: this.form.controls['active'].value ? 'S' : 'N',
      descricao: this.form.controls['description'].value,
    }
  }
}
